import { render, staticRenderFns } from "./ChoiceTableRow.vue?vue&type=template&id=0d58511e&scoped=true&"
import script from "./ChoiceTableRow.vue?vue&type=script&lang=ts&"
export * from "./ChoiceTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceTableRow.vue?vue&type=style&index=0&id=0d58511e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d58511e",
  null
  
)

export default component.exports